/* eslint-disable no-param-reassign */
export const isEmpty = obj => Object.keys(obj).length === 0

export const mapValues = (object, fun) => object.forEach((value, key) => {
  object[key] = fun(value)
})

export const isJSON = (str) => {
  try {
    return JSON.parse(str) && !!str
  } catch (e) {
    return false
  }
}

export const getSubset = (keys, obj) => keys.reduce((a, c) => ({ ...a, [c]: obj[c] }), {})

export const arrangeArray = (a, fn) => {
  const nonMatches = []
  const matches = a.filter((e, i, a) => {
    const match = fn(e, i, a)
    if (!match) nonMatches.push(e)
    return match
  })
  return matches.concat(nonMatches)
}

const themeMap = {
  dotCom: 'asda',
  gi: 'asda',
  george: 'george',
}

export const getThemeString = origin => `theme-${themeMap[origin] || themeMap.dotCom}`

export const trapFocus = (element, lastFocusedElement) => {
  const focusableEls = Array.from(element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'))
  const firstFocusableEl = focusableEls[0]
  const lastFocusableEl = focusableEls[focusableEls.length - 1]
  let currentFocus = null
  
  firstFocusableEl && firstFocusableEl.focus()
  currentFocus = firstFocusableEl

  const handleFocus = (e) => {
    e.preventDefault()
    if (focusableEls.includes(e.target)) {
      currentFocus = e.target
    } else {
      if (currentFocus === firstFocusableEl) {
        lastFocusableEl.focus()
      } else {
        firstFocusableEl.focus()
      }
    }
  }

  document.addEventListener('focus', handleFocus, true)
  
  return {
    onClose: () => {
      document.removeEventListener('focus', handleFocus, true)
      lastFocusedElement && lastFocusedElement.focus()
    },
  }
}